// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XWrO7TFOEi9XRmD9lAdv{background-color:rgba(0,0,0,0);border:1px solid var(--theme-link-color);border-radius:3px;box-sizing:border-box;color:var(--theme-link-color);font-family:rubik,helvetica,arial,sans-serif;font-size:12px;font-style:normal;font-weight:bold;height:36px;line-height:14px;text-align:center;text-transform:uppercase;width:85px}.XWrO7TFOEi9XRmD9lAdv:disabled,.XWrO7TFOEi9XRmD9lAdv[disabled]{border:1px solid #5f7a7b;color:#5f7a7b;opacity:.5}.RkrDbzPil1WhgUESXzQX{margin-bottom:3px;padding:11px 10px;width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `XWrO7TFOEi9XRmD9lAdv`,
	"buttonIsSmall": `RkrDbzPil1WhgUESXzQX`
};
export default ___CSS_LOADER_EXPORT___;
